import React from 'react';
import './footer.scss';

const footer =  ({ ...rest }) => {
  return <footer className={'footer'} {...rest} />;
};


export default footer;